'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.API = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ajax = require('./ajax');

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var API = function () {
    function API(_ref) {
        var apollo = _ref.apollo,
            apiRoot = _ref.apiRoot;

        _classCallCheck(this, API);

        this.apollo = apollo;
        this.root = apiRoot;
    }

    _createClass(API, [{
        key: 'ajaxRequest',
        value: function ajaxRequest(path, callback) {
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var bodyParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

            var url = this.apollo + this.root + path;
            (0, _ajax2.default)(url, callback, method, bodyParams, headers);
        }
    }, {
        key: 'get',
        value: function get(path, callback) {
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            this.ajaxRequest(path, callback, 'GET');
        }
    }, {
        key: 'post',
        value: function post(path, callback) {
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            this.ajaxRequest(path, callback, 'POST', JSON.stringify(params), { 'Content-Type': 'application/json', Accept: 'application/json' });
        }
    }, {
        key: 'crud',
        value: function crud(basePath) {
            var _this = this;

            var allowedMethods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var CrudMethods = {
                get: function get(objId, cb) {
                    return _this.get(basePath + '/' + objId, cb);
                },
                create: function create(data, cb) {
                    return _this.post(basePath, cb, data);
                }
            };

            Object.keys(CrudMethods).filter(function (m) {
                return allowedMethods.indexOf(m) < 0;
            }).forEach(function (disallowedMethod) {
                CrudMethods[disallowedMethod] = function () {
                    throw new Error(disallowedMethod + ' isnt an allowed method for ' + basePath);
                };
            });

            return CrudMethods;
        }
    }]);

    return API;
}();

var apiFactory = function apiFactory(_ref2) {
    var apollo = _ref2.apollo,
        apiRoot = _ref2.apiRoot;

    var _interface = new API({ apollo: apollo, apiRoot: apiRoot });

    return {
        forms: _interface.crud('/forms', ['get']),
        submissions: _interface.crud('/submissions', ['create'])
    };
};

exports.API = API;
exports.default = apiFactory;


//////////////////
// WEBPACK FOOTER
// ./~/icarus-forms/module/js/lib/api.js
// module id = 194
// module chunks = 2 3